const PONTOSENSE_RADAR_SENSOR_MODEL_NAME = 'Silver-Shield-P4';

export const isPontosenseRadarSensor = (device) =>
  device?.modelname === PONTOSENSE_RADAR_SENSOR_MODEL_NAME;

const getFirstValue = (source, keys) => keys.find((key) => source?.[key] !== undefined);

export const getPontosenseAssociationIds = (device) => {
  const tenantKey = getFirstValue(device, [
    'pontosense_tenant_id',
    'pontosenseTenantId',
    'tenant_id',
    'tenantId',
    'tenantid',
  ]);
  const homeKey = getFirstValue(device, [
    'pontosense_home_id',
    'pontosenseHomeId',
    'home_id',
    'homeId',
    'homeid',
  ]);

  return {
    tenantId: tenantKey ? device[tenantKey] : undefined,
    homeId: homeKey ? device[homeKey] : undefined,
  };
};
